import type { User } from '@/shared/types/auth'

/** Grupo que limita la vista a las pestañas Ventas y Registros. */
export const GRUPO_VENTAS_REGISTROS = 'fidelizacion_ventas_registros'

/** Grupos con acceso completo a todas las pestañas de fidelización. */
export const GRUPOS_FIDELIZACION_COMPLETOS = ['admin', 'fidelizacion_admin', 'fidelizacion']

/**
 * Grupos que pueden entrar a la sección "Reportes Fidelización".
 * Se usa en los RequireGroups de las rutas de la sección/pestañas.
 */
export const GRUPOS_FIDELIZACION_VIEW = [...GRUPOS_FIDELIZACION_COMPLETOS, GRUPO_VENTAS_REGISTROS]

/** Pestañas visibles para el perfil restringido (Ventas/Registros). */
export const TABS_VENTAS_REGISTROS = ['registros', 'ventas'] as const

/**
 * True si el usuario solo debe ver las pestañas Ventas y Registros: tiene el
 * grupo `fidelizacion_ventas_registros` y NO tiene acceso completo (admin,
 * fidelizacion_admin, fidelizacion) ni es superuser.
 */
export function esSoloVentasRegistros(user: User | null | undefined): boolean {
  if (!user) return false
  if (user.is_superuser) return false
  if (GRUPOS_FIDELIZACION_COMPLETOS.some((g) => user.groups.includes(g))) return false
  return user.groups.includes(GRUPO_VENTAS_REGISTROS)
}
